export default "__VITE_ASSET__CDLnaAee__"